import { render, staticRenderFns } from "./LinkDetails.vue?vue&type=template&id=0ce769b4"
import script from "./LinkDetails.vue?vue&type=script&lang=js"
export * from "./LinkDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports